import React, { useState, useEffect, useRef } from 'react';
import ApiClient from '../api';
import {message, Select} from "antd";

const api = new ApiClient();

// ── AudiDox Brand Tokens (Dark Mode) ─────────────────────────────────────────
const styles = `  
  /* ── Global dark scrollbars (Webkit + Firefox) ── */ 
  ::-webkit-scrollbar { width: 8px; height: 8px; }
  ::-webkit-scrollbar-track { background: #0D0F14; border-radius: 4px; }
  ::-webkit-scrollbar-thumb { background: #216361; border-radius: 4px; border: 2px solid #0D0F14; }
  ::-webkit-scrollbar-thumb:hover { background: #79A7A5; }
  ::-webkit-scrollbar-corner { background: #0D0F14; }

  .rules-editor-root {
    --bg-base:           #0D0F14;
    --bg-surface:        #161C1C;
    --bg-surface-raised: #1E2828;
    --bg-accent:         #79A7A5;
    --text-primary:      #F0F8F7;
    --text-secondary:    #A0B5B4;
    --text-muted:        #6B8585;
    --text-on-accent:    #0D0F14;
    --border-default:    #216361;
    --border-strong:     #79A7A5;
    --icon-primary:      #79A7A5;
    --status-success:    #79A7A5;
    --status-warning:    #D4A017;
    --status-error:      #E57373;
    --font-xs:   11px;
    --font-sm:   13px;
    --font-base: 15px;
    --font-xl:   24px;

    font-family: 'Space Grotesk', 'Inter', 'Helvetica Neue', Arial, sans-serif;
    background: var(--bg-base);
    color: var(--text-primary);
    padding: 32px;
    min-height: 100%;
    box-sizing: border-box;
  }

  /* ── Header ── */
  .re-header { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 20px; gap: 16px; }
  .re-header-left { display: flex; flex-direction: column; gap: 4px; }
  .re-title { font-size: var(--font-xl); font-weight: 700; color: var(--text-primary); letter-spacing: -0.3px; line-height: 1.3; margin: 0; }
  .re-subtitle { font-size: var(--font-sm); font-weight: 400; color: var(--text-muted); margin: 0; line-height: 1.5; }

  /* ── Policy selector ── */
  .re-policy-row { margin-bottom: 20px; }

  .re-select-wrap { position: relative; display: flex; align-items: center; }

  .re-select {
    width: 100%;
    appearance: none;
    -webkit-appearance: none;
    background: var(--bg-surface);
    color: var(--text-primary);
    border: 1px solid var(--border-default);
    border-radius: 8px;
    padding: 10px 40px 10px 14px;
    font-family: inherit;
    font-size: var(--font-sm);
    font-weight: 500;
    cursor: pointer;
    outline: none;
    transition: border-color 150ms ease-in-out, background 150ms ease-in-out;
  }
  .re-select:hover { border-color: var(--border-strong); }
  .re-select:focus { border-color: var(--border-strong); background: var(--bg-surface-raised); }
  .re-select:disabled { opacity: 0.45; cursor: not-allowed; }
  .re-select option { background: #161C1C; color: #F0F8F7; }

  .re-select-chevron {
    position: absolute;
    right: 13px;
    pointer-events: none;
    color: var(--icon-primary);
    display: flex;
    align-items: center;
  }

  /* ── Card ── */
  .re-card { background: var(--bg-surface); border: 1px solid var(--border-default); border-radius: 12px; overflow: hidden; box-shadow: 0 2px 16px rgba(0,0,0,0.4); }

  /* ── Toolbar ── */
  .re-toolbar { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid var(--border-default); background: var(--bg-surface-raised); gap: 12px; flex-wrap: wrap; }
  .re-toolbar-left { display: flex; align-items: center; gap: 8px; }
  .re-toolbar-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--icon-primary); opacity: 0.6; }
  .re-toolbar-label { font-size: var(--font-sm); font-weight: 500; color: var(--text-secondary); letter-spacing: 0.3px; }
  .re-char-count { font-size: var(--font-xs); color: var(--text-muted); font-variant-numeric: tabular-nums; }

  /* ── Textarea ── */
  .re-textarea {
    width: 100%;
    min-height: calc(100vh / 2);
    padding: 20px 24px;
    background: var(--bg-surface);
    color: var(--text-primary);
    font-family: 'Space Grotesk', 'Inter', 'Helvetica Neue', Arial, sans-serif;
    font-size: var(--font-base);
    font-weight: 400;
    line-height: 1.7;
    border: none;
    outline: none;
    resize: vertical;
    box-sizing: border-box;
    display: block;
    caret-color: var(--bg-accent);
    transition: background 150ms ease-in-out;
  }
  .re-textarea::placeholder { color: var(--text-muted); font-style: italic; }
  .re-textarea:focus { background: var(--bg-surface-raised); }
  .re-soc-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: 8px;
  padding: 6px 8px;
}
.re-soc-toggle-label {
  font-size: var(--font-sm);
  font-weight: 500;
  color: var(--text-secondary);
  padding: 0 4px 0 6px;
  white-space: nowrap;
}
.re-soc-btn-group { display: flex; gap: 4px; }
.re-soc-btn {
  font-family: inherit;
  font-size: var(--font-sm);
  font-weight: 600;
  letter-spacing: 0.3px;
  padding: 7px 16px;
  border-radius: 6px;
  border: 1.5px solid var(--border-default);
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 150ms ease-in-out;
}
.re-soc-btn:hover:not(:disabled) { border-color: var(--border-strong); color: var(--text-primary); }
.re-soc-btn:disabled { opacity: 0.45; cursor: not-allowed; }
.re-soc-btn--yes.re-soc-btn--active { background: var(--status-success); border-color: var(--status-success); color: var(--text-on-accent); }
.re-soc-btn--no.re-soc-btn--active  { background: var(--status-error); border-color: var(--status-error); color: var(--text-on-accent); }

  /* ── Empty state ── */
  .re-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh / 2.5);
    gap: 10px;
    color: var(--text-muted);
    font-size: var(--font-sm);
  }
  .re-empty svg { opacity: 0.25; margin-bottom: 4px; }

  /* ── Footer ── */
  .re-footer { display: flex; align-items: center; justify-content: space-between; padding: 14px 16px; border-top: 1px solid var(--border-default); background: var(--bg-surface-raised); gap: 12px; flex-wrap: wrap; }
  .re-status { font-size: var(--font-xs); font-weight: 500; display: flex; align-items: center; gap: 6px; min-height: 22px; }
  .re-status-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
  .re-status--idle    { color: var(--text-muted); }
  .re-status--saving  { color: var(--text-secondary); }
  .re-status--success { color: var(--status-success); }
  .re-status--error   { color: var(--status-error); }
  .re-status-dot--idle    { background: var(--text-muted); opacity: 0.5; }
  .re-status-dot--saving  { background: var(--status-warning); animation: re-pulse 900ms ease-in-out infinite; }
  .re-status-dot--success { background: var(--status-success); }
  .re-status-dot--error   { background: var(--status-error); }

  @keyframes re-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50%       { opacity: 0.4; transform: scale(0.8); }
  }

  /* ── Buttons ── */
  .re-actions { display: flex; align-items: center; gap: 8px; }
  .re-btn {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 8px 18px; font-family: inherit; font-size: var(--font-sm); font-weight: 500;
    border-radius: 8px; border: none; cursor: pointer;
    transition: all 150ms ease-in-out; letter-spacing: 0.1px; white-space: nowrap;
  }
  .re-btn:focus-visible { outline: 2px solid var(--border-strong); outline-offset: 2px; }
  .re-btn:disabled { opacity: 0.45; cursor: not-allowed; }
  .re-btn--ghost { background: transparent; color: var(--text-secondary); border: 1.5px solid var(--border-default); }
  .re-btn--ghost:hover:not(:disabled) { background: var(--bg-surface); border-color: var(--border-strong); color: var(--text-primary); }
  .re-btn--primary { background: var(--bg-accent); color: var(--text-on-accent); border: 1.5px solid transparent; }
  .re-btn--primary:hover:not(:disabled) { filter: brightness(1.1); }
  .re-btn--primary:active:not(:disabled) { filter: brightness(0.95); transform: translateY(1px); }
  .re-btn-icon { display: flex; align-items: center; }

  /* ── Unsaved badge ── */
  .re-unsaved-badge { display: inline-block; width: 6px; height: 6px; border-radius: 50%; background: var(--status-warning); margin-left: 6px; vertical-align: middle; }
`;

// ── Icons ─────────────────────────────────────────────────────────────────────
const SaveIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
        <polyline points="17 21 17 13 7 13 7 21"/>
        <polyline points="7 3 7 8 15 8"/>
    </svg>
);

const ClearIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6"/>
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
        <path d="M10 11v6M14 11v6"/>
        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
    </svg>
);
const FileIcon = () => (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
        <polyline points="10 9 9 9 8 9"/>
    </svg>
);

// ── Main component ────────────────────────────────────────────────────────────
const SocEditor = () => {

    const [selectedPolicy, setSelectedPolicy]   = useState('');
    const [scaleOfCosts, setScaleOfCosts] = useState(false);

    // ── Editor state
    const [text, setText]                       = useState('');
    const [savedText, setSavedText]             = useState('');
    const [status, setStatus]                   = useState('idle');
    const [statusMsg, setStatusMsg]             = useState('');
    const [editorLoading, setEditorLoading]     = useState(false);
    const statusTimer                           = useRef(null);
    const textareaRef                           = useRef(null);

    const [selectedInsurer, setSelectedInsurer]     = useState(null);
    const [corporate, setCorporate]                 = useState('');

    const [insurersData, setInsurersData]           = useState([]);
    const [availablePolicies, setAvailablePolicies] = useState([]);
    const [roleType, setRoleType]                   = useState(null);


    // Read license once from localStorage
    const license = (() => {
        try { return JSON.parse(localStorage.getItem('user_access') || '{}').license ?? null; }
        catch { return null; }
    })();

    useEffect(() => {
        const loadInsurers = async () => {
            try {
                const user_access = JSON.parse(localStorage.getItem('user_access'));
                const role = user_access?.roletype;
                setRoleType(role);

                const data = await api.get_insurers();
                console.log(data)
                if (data) setInsurersData(data);
            } catch (err) {
                message.error("Failed to load insurer configurations.");
            }
        };
        loadInsurers();
    }, []);

    // ── 2. Load prompt when policy selection changes ──────────────────────────
    useEffect(() => {
        setEditorLoading(true);
        setStatus('idle');
        setStatusMsg('');
        setText('');
        setSavedText('');
        (async () => {
            try {
                // NEW
                console.log('selectedInsurer',selectedInsurer)
                const data = await api.get_soc_prompt(selectedInsurer);

                console.log(data)

                let loaded = '';
                const raw = typeof data === 'string' ? data : data?.soc_prompt;
                if (raw === null || raw === undefined) {
                    loaded = '';
                } else if (typeof raw === 'string') {
                    try {
                        const parsed = JSON.parse(raw);
                        loaded = typeof parsed === 'string' ? parsed : raw;
                    } catch {
                        loaded = raw;
                    }
                } else {
                    loaded = String(raw);
                }
                console.log('loaded text:', loaded);
                setText(loaded);
                setSavedText(loaded);
                setScaleOfCosts(data?.soc_applicable)
            } catch {
                setStatus('error');
                setStatusMsg('Failed to load prompt.');
            } finally {
                setEditorLoading(false);
            }
        })();
    }, [selectedInsurer]);

    // ── Save ──────────────────────────────────────────────────────────────────
    const handleSave = async () => {
        clearTimeout(statusTimer.current);
        setStatus('saving');
        setStatusMsg('Saving…');
        console.log({
            license:license, text:text
        });
        try {
            await api.update_soc_prompt(scaleOfCosts, selectedInsurer, JSON.stringify(text));
            setSavedText(text);
            setStatus('success');
            setStatusMsg('Saved successfully.');
        } catch {
            setStatus('error');
            setStatusMsg('Save failed. Please try again.');
        }
        statusTimer.current = setTimeout(() => { setStatus('idle'); setStatusMsg(''); }, 3500);
    };


    const handleInsurerChange = (license) => {
        const insurer = insurersData.find(i => i.license === license);
        setSelectedInsurer(license);
        console.log('license', license);
        setCorporate(insurer?.company || '');
        setAvailablePolicies(insurer ? insurer.policies : []);
    };
    const renderPolicySelectors = () => {
        return (
            <div style={{display: 'flex', gap: '12px', marginBottom: 12}}>
                <Select
                    placeholder="Select Insurer"
                    style={{flex: 1}}
                    onChange={handleInsurerChange}
                    value={selectedInsurer}
                    options={insurersData.map(i => ({
                        label: i.company || i.license,
                        value: i.license
                    }))}
                    showSearch
                    optionFilterProp="label"
                />
                <div className="re-soc-toggle">
                    <span className="re-soc-toggle-label">Scale of Costs applicable</span>
                    <div className="re-soc-btn-group">
                        <button
                            type="button"
                            className={`re-soc-btn re-soc-btn--yes ${scaleOfCosts === true ? 're-soc-btn--active' : ''}`}
                            onClick={() => setScaleOfCosts(true)}
                            disabled={!selectedInsurer}
                        >
                            YES
                        </button>
                        <button
                            type="button"
                            className={`re-soc-btn re-soc-btn--no ${scaleOfCosts === false ? 're-soc-btn--active' : ''}`}
                            onClick={() => setScaleOfCosts(false)}
                            disabled={!selectedInsurer}
                        >
                            NO
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // ── Clear ─────────────────────────────────────────────────────────────────
    const handleClear = () => {
        setText('');
        textareaRef.current?.focus();
    };

    const isUnsaved = text !== savedText;
    const isSaving = status === 'saving';
    const charCount = text.length;
    const lineCount = text.split('\n').length;

    const statusContent = {
        idle: {label: statusMsg || 'Ready', cls: 're-status--idle'},
        saving: {label: 'Saving…', cls: 're-status--saving'},
        success: {label: statusMsg || 'Saved.', cls: 're-status--success'},
        error: {label: statusMsg || 'An error occurred.', cls: 're-status--error' },
    }[status];

    // ── Render ────────────────────────────────────────────────────────────────
    return (
        <div className="rules-editor-root">
            <style>{styles}</style>

            {/* Header */}
            <div className="re-header">
                <div className="re-header-left">
                    <h2 className="re-title">
                        Policy Rules
                        {isUnsaved && selectedPolicy && !editorLoading && (
                            <span className="re-unsaved-badge" title="Unsaved changes" />
                        )}
                    </h2>
                    <p className="re-subtitle">
                        Select a policy then define its documentation and adjudication rules.
                    </p>
                </div>
            </div>

            {renderPolicySelectors()}

            {/* Editor card */}
            <div className="re-card">

                {/* Toolbar */}
                <div className="re-toolbar">
                    <div className="re-toolbar-left">
                        <div className="re-toolbar-dot" />
                        <span className="re-toolbar-label">
                            {selectedPolicy ? `Prompt — ${selectedPolicy}` : 'Prompt Editor'}
                        </span>
                    </div>
                    {selectedPolicy && !editorLoading && (
                        <span className="re-char-count">
                            {lineCount} line{lineCount !== 1 ? 's' : ''} · {charCount} char{charCount !== 1 ? 's' : ''}
                        </span>
                    )}
                </div>

                {/* Body */}
                {!selectedInsurer ? (
                    <div className="re-empty">
                        <FileIcon />
                        <span>Select a policy above to load or write its prompt.</span>
                    </div>
                ) : (
                    <textarea
                        ref={textareaRef}
                        className="re-textarea"
                        value={editorLoading ? '' : text}
                        onChange={e => setText(e.target.value)}
                        placeholder={editorLoading ? 'Loading…' : 'Write your policy terms here.'}
                        disabled={editorLoading || isSaving}
                        spellCheck={false}
                        aria-label="Policy prompt editor"
                    />
                )}

                {/* Footer */}
                <div className="re-footer">
                    <div className={`re-status ${statusContent.cls}`}>
                        <div className={`re-status-dot re-status-dot--${status}`} />
                        {statusContent.label}
                    </div>

                    <div className="re-actions">
                        <button
                            className="re-btn re-btn--ghost"
                            onClick={handleClear}
                            disabled={editorLoading || isSaving || text === ''}
                            title="Clear editor"
                        >
                            <span className="re-btn-icon"><ClearIcon /></span>
                            Clear
                        </button>

                        <button
                            className="re-btn re-btn--primary"
                            onClick={handleSave}
                            disabled={editorLoading || isSaving || !isUnsaved}
                            title={!selectedPolicy ? 'Select a policy first' : isUnsaved ? 'Save changes' : 'No changes to save'}
                        >
                            <span className="re-btn-icon"><SaveIcon /></span>
                            {isSaving ? 'Saving…' : 'Save & Update'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default SocEditor;